// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { TrackingModel } from "../base/tracking-model";

export class OrganizationalUnitPerson extends TrackingModel {
	public OrganizationalUnitPersonId: number = 0;
	public OrganizationalUnitId: number = 0;
	public PersonId: number = 0;
	public MembershipStatusId?: number;
}